import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from "@mui/material";
import { Ref, forwardRef } from "react";
import { FieldError } from "react-hook-form";

type CSelectProps = SelectProps & {
  label: string;
  options: { label: string; value: string }[];
  helperError?: string | FieldError;
};

const CSelect = forwardRef(
  (
    { label, helperError, options, ...props }: CSelectProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <FormControl fullWidth error={!!helperError} sx={{ gap: "9px" }}>
        <InputLabel
          id={`${props.name}-label`}
          sx={{
            "&.Mui-focused": {
              color: "#808080",
            },
          }}
        >
          {label}
        </InputLabel>
        <Select
          {...props}
          inputRef={ref}
          labelId={`${props.name}-label`}
          label={label}
          sx={{
            "& .MuiOutlinedInput-notchedOutline legend": {
              display: "none",
            },
            height: "51px",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgb(0, 0, 0)",
              borderWidth: 1,
            },
            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
              borderWidth: 2,
            },
          }}
        >
          {options.map(({ label, value }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText sx={{ marginTop: "-3px" }}>
          {typeof helperError === "string" ? helperError : helperError?.message}
        </FormHelperText>
      </FormControl>
    );
  },
);

export default CSelect;
